export const TRANSLATIONS_FR = {
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  login: "CONNEXION",
  registerMsg: "Pas encore inscrit?",
  registerMsg2: "Cliquez ici",
  modalMsg: "Mot de passe et/ou nom d'utilisateur incorrect",
};
